const DocMenuConfig = [
  {
    pages: [
      {
        heading: "DASHBOARD",
        route: "/dashboard",
        svgIcon: "media/icons/duotune/art/art002.svg",
        fontIcon: "bi-app-indicator",
        roles: [
          "superadmin",
          "admin",
          "faculty",
          "irbchair",
          "irbmember",
          "staff",
          "student",
        ],
      },
    ],
  },
  {
    heading: "IRB",
    route: "/irb",
    roles: [
      "superadmin",
      "admin",
      "faculty",
      "irbchair",
      "irbmember",
      "staff",
      "student",
    ],
    pages: [
      {
        sectionTitle: "Application",
        route: "/irb/application/application-options",
        svgIcon: "media/icons/duotune/communication/com012.svg",
        fontIcon: "bi-layers",
        roles: [
          "superadmin",
          "admin",
          "faculty",
          "irbchair",
          "irbmember",
          "staff",
          "student",
        ],
        sub: [
          {
            heading: "New IRB",
            route: "/irb/application/new",
            roles: [
              "superadmin",
              "admin",
              "faculty",
              "irbchair",
              "irbmember",
              "staff",
              "student",
            ],
          },
          {
            heading: "Existing",
            route: "/irb/application/list",
            roles: [
              "superadmin",
              "admin",
              "faculty",
              "irbchair",
              "irbmember",
              "staff",
              "student",
            ],
          },
          {
            heading: "Submitted",
            route: "/irb/application/submitted",
            roles: [
              "superadmin",
              "admin",
              "faculty",
              "irbchair",
              "irbmember",
              "staff",
              "student",
            ],
          },
        ],
      },
      {
        heading: "Collaborative",
        route: "/irb/application/collaborative",
        fontIcon: "bi-people",
        roles: [
          "superadmin",
          "admin",
          "faculty",
          "irbchair",
          "irbmember",
          "staff",
          "student",
        ],
      },
      {
        heading: "Approval Letter",
        route: "/irb/approval-letter",
        fontIcon: "bi-envelope",
        roles: [
          "superadmin",
          "admin",
          "faculty",
          "irbchair",
          "irbmember",
          "staff",
          "student",
        ],
      },
      {
        sectionTitle: "Notification Form",
        route: "/irb/application/notification-options",
        svgIcon: "media/icons/duotune/communication/com008.svg",
        fontIcon: "bi-bell",
        roles: [
          "superadmin",
          "admin",
          "faculty",
          "irbchair",
          "irbmember",
          "staff",
          "student",
        ],
        sub: [
          {
            heading: "New",
            route: "/irb/notification/new",
            roles: [
              "superadmin",
              "admin",
              "faculty",
              "irbchair",
              "irbmember",
              "staff",
              "student",
            ],
          },
          {
            heading: "List",
            route: "/irb/notification/list",
            roles: [
              "superadmin",
              "admin",
              "faculty",
              "irbchair",
              "irbmember",
              "staff",
              "student",
            ],
          },
        ],
      },
    ],
  },
  {
    heading: "FACULTY",
    route: "/faculty",
    roles: ["superadmin", "admin", "faculty", "irbmember", "irbchair"],
    pages: [
      {
        heading: "Sponsor Approval",
        route: "/faculty/sponsor",
        fontIcon: "bi-shield-check",
        roles: ["superadmin", "admin", "faculty", "irbmember", "irbchair"],
      },
    ],
  },
  {
    heading: "IRB MEMBER",
    route: "/member",
    roles: ["superadmin", "admin", "irbmember", "irbchair"],
    pages: [
      {
        heading: "Assigned IRB Applications",
        route: "/member/assigned",
        svgIcon: "media/icons/duotune/communication/com003.svg",
        fontIcon: "bi-list-task",
        roles: ["superadmin", "admin", "irbchair", "irbmember"],
      },
      {
        heading: "Standard IRB Applications",
        route: "/member/standard",
        svgIcon: "media/icons/duotune/communication/com003.svg",
        fontIcon: "bi-book",
        roles: ["superadmin", "admin", "irbchair", "irbmember"],
      },
      {
        heading: "Notification forms",
        route: "/member/notifications",
        svgIcon: "media/icons/duotune/communication/com009.svg",
        fontIcon: "bi-bell",
        roles: ["superadmin", "admin", "irbmember"],
      },
    ],
  },
  {
    heading: "IRB CHAIR",
    route: "/chair",
    roles: ["superadmin", "admin", "irbchair"],
    pages: [
      {
        heading: "IRB Applications",
        route: "/chair/apps",
        svgIcon: "media/icons/duotune/communication/com011.svg",
        fontIcon: "bi-app-indicator",
        roles: ["superadmin", "admin", "irbchair"],
      },
      {
        heading: "Unassigned Expedited",
        route: "/chair/apps-expedited",
        svgIcon: "media/icons/duotune/communication/com011.svg",
        fontIcon: "bi-app-indicator",
        roles: ["superadmin", "admin", "irbchair"],
      },
      {
        heading: "Notification forms",
        route: "/chair/notifications",
        svgIcon: "media/icons/duotune/communication/com008.svg",
        fontIcon: "bi-bell",
        roles: ["superadmin", "admin", "irbchair"],
      },
      {
        heading: "Transaction Logs",
        route: "/chair/transaction-logs",
        svgIcon: "media/icons/duotune/communication/com011.svg",
        fontIcon: "bi-app-indicator",
        roles: ["superadmin", "admin", "irbchair"],
      },

      {
        heading: "User List",
        route: "/admin/users/list",
        svgIcon: "media/icons/duotune/communication/com011.svg",
        fontIcon: "bi-app-indicator",
        roles: ["superadmin", "admin", "irbchair"],
      },
      {
        heading: "User Pending",
        route: "/admin/users/pending",
        svgIcon: "media/icons/duotune/communication/com008.svg",
        fontIcon: "bi-bell",
        roles: ["superadmin", "admin", "irbchair"],
      },
    ],
  },
  {
    heading: "ADMIN",
    route: "",
    roles: ["superadmin", "admin", "irbchair"],
    pages: [
      {
        sectionTitle: "Users",
        route: "/admin/users/user-options",
        svgIcon: "media/icons/duotune/communication/com012.svg",
        fontIcon: "bi-layers",
        roles: ["superadmin", "admin", "irbchair"],
        sub: [
          {
            heading: "List",
            route: "/admin/users/list",
            roles: ["superadmin", "admin", "irbchair"],
          },
          {
            heading: "Pending",
            route: "/admin/users/pending",
            roles: ["superadmin", "admin", "irbchair"],
          },
        ],
      },
    ],
  },
  {
    heading: "Issues",
    route: "/admin/issues/list",
    roles: [
      "superadmin",
      "admin",
      "faculty",
      "irbchair",
      "irbmember",
      "staff",
      "student",
    ],
    pages: [
      {
        heading: "Review Issues",
        route: "/admin/issues/list",
        svgIcon: "media/icons/duotune/communication/com012.svg",
        fontIcon: "bi-layers",
        roles: [
          "superadmin",
          "admin",
          "faculty",
          "irbchair",
          "irbmember",
          "staff",
          "student",
        ],
      },
    ],
  },
];

export default DocMenuConfig;
